export const REPLACE_PRACTICE_FIELDS = 'REPLACE_PRACTICE_FIELDS';
export const SET_PRACTICE_AREA_ACTIONS = 'SET_PRACTICE_AREA_ACTIONS';